/** Created by azhou on 2019/2/28.*/
<template>
    <div>
      <public-title >
          会场资料
        <span class="text-link ml-auto h6" slot="right" @click="$router.back()" v-if="storeId">返回上一页</span>
      </public-title>
      <div class="load-area">
        <!-- <group-r-m-c-list v-if="isGroup && !storeId" :type="2"></group-r-m-c-list> -->
        <room-meet-lists class="p-4 bg-white w-d"/>
      </div>
    </div>
</template>

<script>
  import { mapState,mapGetters,mapMutations } from 'vuex'
  import RoomMeetLists from './Comps/RoomMeetLists'
 import GroupRMCList from './GroupRMCList.vue'
  export default {
    name: 'GroupMeeting',
    computed: {
      ...mapState(['currentStoreInfo']),
      ...mapGetters(['storeInfo','isGroup']),
      queryStoreId() { return this.$route.query.storeId },
      step() { return this.$route.query.step },
      storeId() { return this.$route.query.storeId },
    },
    watch:{
      step(newVal) { this.activeName = newVal; },
    },
    data() {
      return {
        activeName:''
      }
    },
    components:{ RoomMeetLists,GroupRMCList },
    mounted() {
      this.UPDATECURRENTSTORE({storeId:this.queryStoreId});
      this.activeName = this.$route.query.step + '';
    },
    destroyed() { this.UPDATECURRENTSTORE({storeId:''}) },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      changeTab(tab) {
        this.$router.replace({name:this.$route.name,query:{...this.$route.query,step:tab.name}})
      }
    }
  }
</script>
